import Header from "../../components/User/Header";
import {
  Box,
  Container,
  Paper,
  Typography,
} from "@mui/material";
import React from "react";
import { useSidebar } from "../../components/SidebarContext";

export const Guide = () => {
  // Card data for mapping
  const cards = [
    {
      id: 1,
      title: "Lost something? No worries!",
      content:
        "Just describe your item or upload a picture, and UFind will instantly search for matches. If someone reports a similar item, you'll get a notification right away!",
      backgroundColor: "#e1ecc8",
      textColor: "#516d4f",
    },
    {
      id: 2,
      title: "Found an item? Help return it!",
      content:
        "Upload a photo and details, and UFind will connect it with lost item reports. Our smart matching system makes it easy to reunite belongings with their owners.",
      backgroundColor: "#516d4f",
      textColor: "#fbffe8",
    },
    {
      id: 3,
      title: "No more endless searching!",
      content:
        "UFind's AI-powered system quickly matches lost and found items using descriptions and images. Get real-time updates and retrieve your belongings hassle-free!",
      backgroundColor: "#e1ecc8",
      textColor: "#516d4f",
    },
  ];

  const { isSidebarOpen } = useSidebar();
  const isMobile = /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth <= 600;

  return (
    <Box
      sx={{
        transition: "margin-left 0.3s cubic-bezier(0.4,0,0.2,1), max-width 0.3s cubic-bezier(0.4,0,0.2,1)",
        marginLeft: isSidebarOpen ? (isMobile ? "200px" : "300px") : 0,
        bgcolor: "#fbffe8",
        minHeight: "100vh",
        width: "100%",
        maxWidth: isSidebarOpen ? (isMobile ? "calc(100vw - 200px)" : "calc(100vw - 300px)") : "100vw",
        overflowX: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header title="About UFind" />
      <Container
        maxWidth="xl"
        sx={{ position: "relative", pt: { xs: 2, md: 3 }, pb: 4 }}
      >
        {/* Cards Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 3, md: 4 },
            justifyContent: "space-between",
            mb: 4,
            alignItems: { xs: "center", md: "flex-start" },
          }}
        >
          {cards.map((card) => (
            <Paper
              key={card.id}
              elevation={4}
              sx={{
                bgcolor: card.backgroundColor,
                borderRadius: "20px",
                p: { xs: 2.5, sm: 3.5, md: 4 },
                width: "100%",
                maxWidth: { xs: "100%", sm: "500px", md: "440px" },
                height: "auto",
                minHeight: { xs: "auto", md: "445px" },
                display: "flex",
                flexDirection: "column",
                position: "relative",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontFamily: "Poppins, Helvetica",
                  fontWeight: 700,
                  color: card.textColor,
                  fontSize: { xs: "18px", sm: "22px", md: "24px" },
                  mb: { xs: 2, sm: 3, md: 8 },
                  lineHeight: 1.3,
                }}
              >
                {card.title}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Poppins, Helvetica",
                  color: card.textColor,
                  fontSize: { xs: "14px", sm: "18px", md: "20px" },
                  lineHeight: 1.6,
                }}
              >
                {card.content}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Guide;